<template>
  <div id="box">
    <ValidationObserver
      v-slot="{ invalid }"
      ref="myForm"
      tag="form"
      @submit.prevent="submit"
    >
      <div class="inner">
        <div class="scrollWrapper">
          <div class="expandWrapper">
            <h1 v-html="$t('authorization.title')" />
            <div class="tabWrappers" v-show="!isMobile">
              <Tab :tabType="'email'" :isSelected="true" />
              <Tab
                :tabType="'qrcode'"
                :isSelected="false"
                @tab="toQRCodePage"
              />
            </div>
            <p v-html="$t('authorization.description')" class="description" />
            <InputEmail v-model="emailValue" />
          </div>
        </div>
        <div class="wrapper">
          <CustomButton
            :disabled="invalid"
            :isDisabled="invalid"
            :isLoading="customButtonLoading"
            :buttonType="'primary'"
            :customButtonTxt="$t('customButton.next')"
            @submit="submit"
          />
          <a
            href="https://x-id.me/"
            target="_blank"
            v-html="$t('authorization.noAccount')"
            class="companyLink"
          />
        </div>
      </div>
    </ValidationObserver>
  </div>
</template>

<script>
import { ValidationObserver } from "vee-validate";
import InputEmail from "../components/inputEmail.vue";
import CustomButton from "../components/customButton.vue";
import Tab from "../components/tab.vue";
import { isMobileOnly } from "mobile-device-detect";

export default {
  name: "EnterEmail",
  components: {
    ValidationObserver,
    InputEmail,
    CustomButton,
    Tab,
  },
  props: {
    invalidEmail: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      customButtonLoading: false,
      emailValue: "",
    };
  },
  watch: {
    invalidEmail: {
      deep: true,
      handler: function (newVal) {
        this.customButtonLoading = false;
        if (newVal != true) {
          return;
        }
        this.$refs.myForm.setErrors({
          email: [this.$t("serverError.unregistered")],
        });
      },
    },
  },
  computed: {
    isMobile() {
      return isMobileOnly == true;
    },
  },
  methods: {
    submit() {
      if (this.customButtonLoading == true) {
        return;
      }
      this.customButtonLoading = true;
      this.$emit("authorization", this.emailValue);
    },
    toQRCodePage() {
      this.$emit("navigate", { page: "QRCodeAuthorization", errorType: "" });
    },
  },
};
</script>

<style lang="sass" scoped>
#box
  form
    +size(100%)
    .wrapper
      margin-top: 12px
      .customButtonWrapper
        +customButton(100%, primary)
</style>
